import React, { useContext } from 'react';
import clsx from 'clsx';
import { Link } from 'gatsby';

import { LayoutContext } from '../../contexts/LayoutContext';
import { getUrlFromNavItem } from '../../lib/helpers';

import styles from './internal-link.module.scss';

export function InternalLink({ className, children, to, node = {}, variant = 'normal', ...other }) {
  const { startPageId } = useContext(LayoutContext);
  const { reference } = node;

  if (!children) {
    // Possible empty label.
    return null;
  }

  return !reference ? (
    // Possible empty reference.
    children
  ) : (
    <Link
      className={clsx(styles.internalLink, variant === 'thin' && styles.thin, className)}
      activeClassName={styles.active}
      to={getUrlFromNavItem({ id: reference._id, type: reference._type, slug: reference.slug.current }, startPageId)}
      {...other}
    >
      {children}
    </Link>
  );
}
